import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import BookListItem from './BookListItem';

const BookRelatedBooks = ({ bookList=null, title=<span>연관도서</span> })=>{
    const { school } = useParams();
    const location = useLocation();
    if( null===bookList  || bookList.length===0)return null;

    let bookListItem = bookList.map( (book, key)=>{
        if(key>4)return null;
        return (
            <li key={book.isbn} >
                <Link to={`/${school}/book/${book.isbn}?${location.search}`} >
                    <BookListItem book={book} />
                </Link>
            </li>
        )
    });
    
    return (
        <div className="section">
            <h3 className="alignC"> {title} </h3>
            <div className="related_books">
                <ul className="clear">
                    {bookListItem}
                </ul>
            </div>
        </div>
    );
}
export default BookRelatedBooks;